module.exports = __webpack_public_path__ + "static/media/logo_rjh_white.b2218a75.png";